export const blogPosts = [
  {
    slug: 'klima-santrali-secimi',
    title: 'Klima Santrali Seçimi Nasıl Yapılır? | 5 Adımda Rehber',
    date: '2025-07-21',
    excerpt: 'HVAC projelerinde doğru klima santrali seçimi için dikkat edilmesi gereken 5 temel adımı bu rehberde bulabilirsiniz.',
    category: 'Klima Santrali',
    image: '/assets/klima-secimi-cover.png',
    markdown: '/blog-content/klima-santrali-secimi.md'
  },
  {
    slug: 'psikrometrik-diagram',
    title: 'Psikrometrik Diyagram Kullanımı',
    date: '2025-07-27',
    excerpt: 'Psikrometrik diyagram, nemli havanın fiziksel özelliklerini grafik halinde veren bir diyagramdır. Kullanımını örneklerle açıklıyoruz.',
    category: 'Temel Bilgiler',
    image: '/assets/psikrometrik-kapak.png',
    markdown: '/blog-content/psikrometrik-diagram.md'
  },
  {
    slug: 'hava-degisim-debisi',
    title: 'Hava Değişim Katsayısı ve Debi Hesabı | Klima Santrali Rehberi',
    date: '2025-08-04',
    excerpt: 'Hava değişim katsayısı (ACH) nedir? Klima santrali için gerekli hava debisi nasıl hesaplanır? Örneklerle açıklıyoruz.',
    category: 'Klima Santrali',
    image: '/assets/hava-degisim-cover.png',
    markdown: '/blog-content/hava-degisim-debisi.md'
  },
  {
    slug: 'kanal-basinc-kaybi',
    title: 'Havalandırma Kanallarında Oluşacak Basınç Kaybının Belirlenmesi',
    date: '2025-08-04',
    excerpt: 'Kanal içi hava akışında meydana gelen sürtünme ve yerel basınç kayıplarını nasıl hesaplarsınız? Formüllerle ve örneklerle detaylı açıklıyoruz.',
    category: 'Havalandırma',
    image: '/assets/kanal-basinckaybi-cover.png',
    markdown: '/blog-content/kanal-basinc-kaybi.md'
  },
   {
    slug: 'klima-santrali-filtre',
    title: 'Klima Santrallerinde Filtrasyon: Teknik Bir Bakış',
    date: '2025-08-06',
    excerpt: 'Klima santrali tasarımında filtre seçiminin önemini, basınç kaybını ve tasarım detaylarını örneklerle açıklıyoruz.',
    category: 'Klima Santrali',
    image: '/assets/filtre_kapak_oranli.png',
    markdown: '/blog-content/klima-santrali-filtre.md'
  },
{
    slug: 'klima-santralleri-isitma-sogutma',
    title: 'Klima Santrallerinde Kullanılan Isıtma ve Soğutma Yöntemleri',
    date: '2025-08-07',
    excerpt: 'Klima santrallerinde kullanılan ısıtma ve soğutma yöntemlerinin artıları ve eksilerini yazımızdan inceleyin.',
    category: 'Klima Santrali',
    image: '/assets/klima-isitma-sogutma.png',
    markdown: '/blog-content/klima-santralleri-isitma-sogutma.md'
  },
  {
    slug: 'isi-geri-kazanim-teknik-inceleme',
    title: 'Isı Geri Kazanım Cihazı Teknik İnceleme',
    date: '2025-08-11',
    excerpt: 'Isı Geri Kazanım (IGK) cihazlarının çalışma prensibi ve örnekli ısı kazancı hesaplamalarını yazımızdan inceleyin.',
    category: 'Havalandırma',
    image: '/assets/isi-geri-kazanim-teknik-inceleme.png',
    markdown: '/blog-content/isi-geri-kazanim-teknik-inceleme.md'
  },
    {
    slug: 'klima-santrali-konfigurasyonlari',
    title: 'Klima Santrali Konfigürasyoları',
    date: '2025-09-09',
    excerpt: 'Klima santrali konfigürasyonlarının detaylı ve görselli açıklamalarını öğrenin.',
    category: 'Klima Santrali',
    image: '/assets/klima-santrali-konfigurasyon.png',
    markdown: '/blog-content/klima-santrali-konfigurasyonlari.md'
  },
      {
    slug: 'klima-santrali-termal-kopruleme',
    title: 'Klima Santrali Termal Köprüleme (TB)',
    date: '2025-09-10',
    excerpt: 'Bu yazıda, TB1’in ne olduğunu, neden önemli olduğunu ve klima santralinizin performansını ve güvenilirliğini nasıl üst seviyeye çıkarabileceğinizi açıklayacağız.',
    category: 'Klima Santrali',
    image: '/assets/thermal-performance.png',
    markdown: '/blog-content/klima-santrali-termal-kopruleme.md'
  },
        {
    slug: 'hepa-filtreler-secim-montaj-bakim',
    title: 'Hepa Filtre: Seçim, Montaj ve Bakım',
    date: '2025-09-11',
    excerpt: 'HEPA filtrelerin hastanelerde hava kalitesini nasıl artırdığını, sağlık HVAC sistemlerinde en uygun şekilde nereye yerleştirilmeleri gerektiğini ve doğru bakımın uzun vadeli güvenliği nasıl sağladığını inceleyeceğiz.',
    category: 'Klima Santrali',
    image: '/assets/hepa-assembly.png',
    markdown: '/blog-content/hepa-filtreler-secim-montaj-bakim.md'
  },
          {
    slug: 'hastanelerde-negatif-basincli-odalar',
    title: 'Hastanelerde Negatif Basınçlı Odalar',
    date: '2025-09-15',
    excerpt: 'Bu makale, negatif basınçlı odaların ne olduğunu, hastanelerdeki önemini ve HVAC tasarımının güvenli çalışmayı nasıl sağladığını açıklamaktadır.',
    category: 'Havalandırma',
    image: '/assets/negative-pressure-rooms.png',
    markdown: '/blog-content/hastanelerde-negatif-basincli-odalar.md'
  }
];
